import Link from "@/components/AppLink";
import { getDashboardPathUrl } from "@/config/dashboardOrigin";

const CallToAction = () => {
  return (
    <section className="call-action-inner third">
      <div className="overlay pt-120">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-lg-9 d-flex align-items-center justify-content-center">
              <div className="section-header text-center">
                <h3>Pricing you can quote to clients with confidence.</h3>
                <p>
                  Receiving freelancer payouts shows clear processing costs up
                  front. FX conversions use live rates with nothing buried in
                  the fine print.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="bottom-area text-center">
                <p className="xxlr">Most accounts activate the same day.</p>
                <Link href={getDashboardPathUrl("/register")} className="cmn-btn">
                  Request a Payment Now
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
